
import { size } from 'lodash';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { emitter } from '../../../utils/emitter';
class ModalProduct extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            title: '',
            shortDescription: '',
            description: '',
            originalPrice: '',
            salePrice: '',
            isPromotion: '',
            promotionPercent: '',
            isFreeShip: '',
            category: '',
            thumbnail: '',
            color: '',
            size: '',
            model: '',
            country: '',
            originalLink: '',



            /*
            {
             "updated_by": {
                "id": 1,
                "username": "haunguyen",
                "firstname": null,
                "lastname": null
                },
        
            "category": {
                    "id": 1,
                    "name": "Thời trang",
                    "searchTerm": "ao so mi nu",
                    "created_by": null,
                    "updated_by": null,
                    "created_at": "2020-10-18T06:06:55.456Z",
                    "updated_at": "2020-10-18T06:06:55.456Z"
            },
            "thumbnail": {
                "id": 4,
                "name": "ao-so-mi-nu.jpg",
                "alternativeText": "",
                "caption": "",
                "width": 444,
                "height": 444,

                "formats": {
                    "thumbnail": {
                    "ext": ".jpg",
                    "url": "/uploads/thumbnail_6858c731526834013c23d3fb5ea7a78c_f67cc14060.jpg",
                    "hash": "thumbnail_6858c731526834013c23d3fb5ea7a78c_f67cc14060",
                    "mime": "image/jpeg",
                    "name": "thumbnail_6858c731526834013c23d3fb5ea7a78c.jpg",
                    "path": null,
                    "size": 7.04,
                    "width": 156,
                    "height": 156
                                 }
                             },
                "hash": "9ff7d29c2ebad4fd802685eb770d9452_417240087a",
                "ext": ".jpg",
                "mime": "image/jpeg",
                "size": 32.65,
                "url": "/uploads/9ff7d29c2ebad4fd802685eb770d9452_417240087a.jpg",
                "previewUrl": null,
                "provider": "local",
                "provider_metadata": null,
                "created_at": "2020-12-06T15:03:52.090Z",
                "updated_at": "2020-12-06T15:04:32.528Z",
                "created_by": 1,
                "": 1
                }
                },
            
            
            */


        }
        this.listenToEmitter();
    }
    listenToEmitter() {
        emitter.on('EVENT_CLEAR_MODAL_DATA', data => {
            this.setState({
                name: '',
                title: '',
                shortDescription: '',
                description: '',
                originalPrice: '',
                salePrice: '',
                isPromotion: '',
                promotionPercent: '',
                isFreeShip: '',
                category: '',
                thumbnail: '',
                color: '',
                size: '',
                model: '',
                country: '',
                originalLink: '',
            })
            console.log('emittet', data)
        });
    }
    componentDidMount() {
        // console.log('',)
    }
    toggle = () => {
        this.props.tooglefromParent()
    }
    handleOnchangeInput = (event, id) => {
        // bad code this.state[id] = event.target.value , ko nen update truc tiep
        // good code, thong qua 1 bien trung gian
        let copyState = { ...this.state }; // copy state moi
        copyState[id] = event.target.value
        this.setState({
            ...copyState
        }, () => { // callback function

        })
        console.log("copyState: ", copyState)
        console.log(event.target.value, id)
    }
    checkValideInput = () => {
        let arrInput = [
            'name',
            'title',
            'shortDescription',
            'description',
            'originalPrice',
            // 'salePrice',
            // 'isPromotion',
            'promotionPercent',
            // 'isFreeShip',
            'thumbnail',
            'color',
            'originalLink',

        ];

        let isValide = true;
        for (let i = 0; i < arrInput.length; i++) { // neu dung vong lap MAP thi ko the dung break, foreach

            if (!this.state[arrInput[i]]) {
                isValide = false
                alert("Missing parameters" + arrInput[i]);
                break;
            }
        }
        return isValide
    }
    handleAddNewProduct = () => {
        let isValide = this.checkValideInput();
        if (isValide == true) {
            this.props.createNewProduct(this.state)
        }


        // console.log("data modal: ", this.state)
    }

    render() {
        // console.log('check child props:', this.props);
        // console.log('check child open modal:', this.props.isOpen);
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.toggle}
                className="modal-product-container"
                size="lg"
                centered
            >
                <ModalHeader toggle={this.toggle}>Creating new Product</ModalHeader>
                <ModalBody>
                    <div className='modal-product-body'>

                        <div className='input-container'>
                            <label>Name: </label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter product name"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'name')
                                }}
                                value={this.state.product}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Title: </label>
                            <input
                                type="text"
                                name="title"
                                placeholder="Enter link to the image"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'title')
                                }}
                            // value={this.state.title}
                            />
                        </div>
                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container'>
                            <label>Discount: %</label>
                            <input
                                type="text"
                                name="promotionPercent"
                                placeholder="Enter discount"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'promotionPercent')
                                }}
                            // value={this.state.promotionPercent}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Color: </label>
                            <input
                                type="text"
                                name="color"
                                placeholder="Enter color of the product"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'color')
                                }}
                            // value={this.state.color}
                            />
                        </div>
                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container'>
                            <label>Location: </label>
                            <select name="country" id="country" class="form-control">
                                <option selected>Choose Country</option>
                                {this.props.countries && this.props.countries.map((item, index) => {
                                    // console.log('check map', item, index);
                                    return (
                                        <option value={index}> {item.countryName} </option>

                                    )
                                })}

                            </select>
                        </div>
                        <div className='input-container'>
                            <label>Price: </label>
                            <input
                                type="text"
                                name="originalPrice"
                                placeholder="Enter price"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'originalPrice')
                                }}
                            />
                        </div>

                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container'>
                            <label>Category: </label>
                            <select name="category" id="category" class="form-control">
                                <option selected>Choose Category</option>
                                {this.props.categories && this.props.categories.map((item, index) => {
                                    // console.log('check map', item, index);
                                    return (
                                        <option value={index}> {item.categoryName} </option>

                                    )
                                })}
                            </select>
                        </div>
                        <div className='input-container'>
                            <label>Select image:</label>
                            <input type="file" id="img" name="img" accept="file_extension|audio/*|video/*|image/*|media_type" />
                            {/* <input /> */}
                        </div>

                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container max-width-input'>
                            <label>Thumbnail: </label>
                            <input
                                type="text"
                                name="thumbnail"
                                placeholder="Enter thumbnail"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'thumbnail')
                                }}
                            />
                        </div>
                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container max-width-input'>
                            <label>Original link: </label>
                            <input
                                type="text"
                                name="originalLink"
                                placeholder="Enter original link of the product"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'originalLink')
                                }}
                            />
                        </div>


                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container max-width-input'>
                            <label>Short Description: </label>
                            <input
                                type="text"
                                name="shortDescription"
                                placeholder="Enter short description"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'shortDescription')
                                }}
                            />
                            <label>Description: </label>
                            <textarea
                                type="text"
                                name="description"
                                placeholder="Enter description"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'description')
                                }}
                            />
                        </div>

                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className='px-2' color="primary" onClick={this.handleAddNewProduct}>Add New</Button>{' '}
                    <Button className='px-2' color="secondary" onClick={this.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        )
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalProduct);


